<template>
  <div class="content">
    <heads :more="showMore" :msg="title_msg"></heads>
    <div class="agreement" v-html="html">
    </div>
  </div>
</template>

<script>
import { getAgreement } from '@/api/regInfo.js'
import heads from '@/components/common/heads.vue'
export default {
  components: { heads },
  data() {
    return {
      title_msg: '协议',
      showMore: true,
      html: '',
      type: this.$route.query.type || '4'
    }
  },
  created() {
    // 请求数据
    this.getAgreement()
  },
  methods: {
    getAgreement() {
      getAgreement({ type: this.type }).then((res) => {
        console.log(res)
        const errNo = res.errNo
        if (errNo == 0) {
          const result = res.result || {}
          this.html = result.agreement || ''
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.agreement {
  padding: 40px;
  color: #333 !important;
  font-size: 28px !important;
  overflow-x: hidden;
  p{
    span{
      white-space:normal !important;
    }
  }
}

/deep/img {
  max-width: 100% !important;
}
</style>
